module.exports = __webpack_public_path__ + "static/app-shot-1-2-e81bcb0f6407178b14a8f49b5ec39b60.jpg";